<template>
    <b-form>
        <div class="tab-header mb-4">Basic Information</div>
        <b-row>
            <b-col md="4">
                <b-form-group
                    label="First Name"
                    label-for="firstname"
                    :state="isValid('firstname')"
                    :invalid-feedback="errorMessage('firstname')">
                    <b-form-input
                        type="text"
                        v-model="form.firstname"
                        maxlength="20">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group
                    label="Last Name"
                    label-for="lastname"
                    v-model="form.lastname"
                    :invalid-feedback="errorMessage('lastname')"
                    :state="isValid('lastname')">
                    <b-form-input
                        type="text"
                        v-model="form.lastname"
                        maxlength="20">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group
                    label="Membership ID No."
                    label-for="membership_id"
                    :invalid-feedback="errorMessage('membership_id')"
                    :state="isValid('membership_id')">
                    <b-form-input type="text" v-model="form.membership_id" :disabled="!whitelist" :readonly="!whitelist" v-bind:class="{ 'text-primary': !whitelist }" maxlength="40"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4">
                <b-form-group
                    label="Email"
                    label-for="email"
                    :state="isValid('email')"
                    :invalid-feedback="errorMessage('email')">
                    <b-form-input
                        type="text"
                        v-model="form.email"
                        maxlength="40"
                        disabled>
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group label="Mobile No." 
                    label-for="mobile_number"
                    :state="isValid('mobile_number')"
                    :invalid-feedback="errorMessage('mobile_number')">
                    <b-input-group>
                        <b-input-group slot="prepend">+63</b-input-group>
                        <b-form-input
                            type="text"
                            v-model="form.mobile_number"
                            v-on:keypress="isNumber"
                            disabled
                            maxlength="10">
                        </b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group
                    label="Registration Channel"
                    label-for="registration_channel"
                    :state="isValid('registration_channel')"
                    :invalid-feedback="errorMessage('registration_channel')">
                    <b-form-select
                        v-model="form.registration_channel"
                        :options="regchannel"
                        disabled>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group
                    label="Gender"
                    label-for="gender"
                    :state="isValid('gender')"
                    :invalid-feedback="errorMessage('gender')">
                    <b-form-select
                        v-model="form.gender"
                        :options="gender">
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group
                    label="Civil Status"
                    label-for="civil_status"
                    :state="isValid('civil_status')"
                    :invalid-feedback="errorMessage('civil_status')">
                    <b-form-select
                        v-model="form.civil_status"
                        :options="civil_status_options">
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group
                    label="Birth Date"
                    label-for="birthdate"
                    :state="isValid('birthdate')"
                    :invalid-feedback="errorMessage('birthdate')">
                    <b-input-group>
                        <b-input-group slot="append">
                            <i class="icon-calendar"></i>
                        </b-input-group>
                        <datepicker
                            :config="singleDateConfig"
                            v-model="form.birthdate"

                            readonly>
                        </datepicker>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4">
                <b-form-group
                    label="Address 1"
                    label-for="address_1"
                    :state="isValid('address_1')"
                    :invalid-feedback="errorMessage('address_1')">
                    <b-form-input
                        type="text"
                        v-model="form.address_1"
                        maxlength="40">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group
                    label="Address 2"
                    label-for="address_2"
                    :state="isValid('address_2')"
                    :invalid-feedback="errorMessage('address_2')">
                    <b-form-input
                        type="text"
                        v-model="form.address_2"
                        maxlength="40">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group
                    label="City"
                    label-for="city"
                    :state="isValid('city')"
                    :invalid-feedback="errorMessage('city')">
                    <b-form-input
                        type="text"
                        v-model="form.city"
                        maxlength="40">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group
                    label="Province"
                    label-for="province"
                    :state="isValid('province')"
                    :invalid-feedback="errorMessage('province')">
                    <b-form-input
                        type="text"
                        v-model="form.province"
                        maxlength="40">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group
                    label="Zip Code"
                    label-for="zipcode"
                    :state="isValid('zipcode')"
                    :invalid-feedback="errorMessage('zipcode')">
                    <b-form-input
                        type="text"
                        v-model="form.zipcode"
                        maxlength="40">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <template v-if="additional">
            <hr>
            <div class="tab-header mb-4">Additional Information</div>
            <b-row>
            </b-row>
            <b-row>
                <b-col md="3" v-if="enable.country">
                    <b-form-group
                        label="Country"
                        label-for="country"
                        :state="isValid('country')"
                        :invalid-feedback="errorMessage('country')">
                        <b-form-select
                            v-model="form.country"
                            :options="countries">
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" v-if="enable.province">
                    <b-form-group
                        label="Province"
                        label-for="province"
                        :state="isValid('province')"
                        :invalid-feedback="errorMessage('province')">
                        <b-form-input
                            type="text"
                            v-model="form.province"
                            maxlength="30">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="3" v-if="enable.city">
                    <b-form-group
                        label="City / Municipality"
                        label-for="city"
                        :state="isValid('city')"
                        :invalid-feedback="errorMessage('city')">
                        <b-form-input
                            type="text"
                            v-model="form.city"
                            maxlength="30">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="3" v-if="enable.zipcode">
                    <b-form-group
                        label="Zipcode"
                        label-for="zipcode"
                        :state="isValid('zipcode')"
                        :invalid-feedback="errorMessage('zipcode')">
                        <b-form-input
                            type="text"
                            v-model="form.zipcode"
                            v-on:keypress="isNumber"
                            maxlength="4">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" v-if="enable.text1">
                    <template v-if="merchantUuid == 'aa1c538b-df7e-4654-be6e-d7e6f5977d53' || merchantUuid == '6e277127-5e4b-48aa-a15c-0e1757d3a5a2'">
                        <div id="date-registered-group">
                            <b-form-group
                                :label="custom_fields.text1"
                                label-for="text1"
                                :state="isValid('text1')"
                                :invalid-feedback="errorMessage('text1')"
                            >
                                <b-input-group class="custom-datepicker mb-3 muli-sb d-flex">
                                    <b-input-group-text slot="append" class="bg-transparent">
                                        <img src="@/assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button"
                                            @click="openCalendar('start')">
                                    </b-input-group-text>
                                    <SingleDatepicker
                                        :bootstrap-styling="true"
                                        :value="form.text1"
                                        ref="datepicker_start"
                                        v-model="form.text1"
                                        wrapper-class="custom-datepicker"
                                        :style="{color: '#2a2a2a !important', width: '124px'}"
                                    />
                                </b-input-group>
                            </b-form-group>
                        </div>
                    </template>
                    <template v-else>
                        <b-form-group
                            :label="custom_fields.text1"
                            label-for="text1"
                            :state="isValid('text1')"
                            :invalid-feedback="errorMessage('text1')">
                            <b-form-input
                                type="text"
                                v-model="form.text1"
                                maxlength="30">
                            </b-form-input>
                        </b-form-group>
                    </template>
                </b-col>
                <b-col md="3" v-if="enable.text2">
                    <b-form-group
                        :label="custom_fields.text2"
                        label-for="text1"
                        :state="isValid('text2')"
                        :invalid-feedback="errorMessage('text2')">
                        <b-form-input
                            type="text"
                            v-model="form.text2"
                            maxlength="30">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="3" v-if="enable.text3">
                    <b-form-group
                        :label="custom_fields.text3"
                        label-for="text3"
                        :state="isValid('text3')"
                        :invalid-feedback="errorMessage('text3')">
                        <b-form-input
                            type="text"
                            v-model="form.text3"
                            maxlength="30">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="3" v-if="enable.text4">
                    <b-form-group
                        :label="custom_fields.text4"
                        label-for="text4"
                        :state="isValid('text4')"
                        :invalid-feedback="errorMessage('text4')">
                        <b-form-input
                            type="text"
                            v-model="form.text4"
                            maxlength="30">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="3" v-if="enable.text5">
                    <b-form-group
                        :label="custom_fields.text5"
                        label-for="text5"
                        :state="isValid('text5')"
                        :invalid-feedback="errorMessage('text5')">
                        <b-form-input
                            type="text"
                            v-model="form.text5"
                            maxlength="30">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </template>
        <input type="hidden" v-model="form.uuid" />
        <b-button variant="primary btn-update-profile" slot="modal-footer" @click="updateCustomer">Update Profile</b-button>
    </b-form>
</template>

<script>
import Datepicker from "vue-bulma-datepicker";
import SingleDatepicker from "vuejs-datepicker";

const countries = require("@datasets/country-list");

const genders = [
    {
        value: "Male",
        text: "Male"
    },
    {
        value: "Female",
        text: "Female"
    }
];
const civil_status_options = [
    { value: "Single", text: "Single" },
    { value: "Married", text: "Married" },
    { value: "Separated", text: "Separated" },
    { value: "Widow/Widower", text: "Widow/Widower" }
];
const reg_channel = [
    {
        value: "iOS App",
        text: "iOS App"
    },
    {
        value: "Android App",
        text: "Android App"
    },
    {
        value: "Employee",
        text: "Employee"
    }
];

import { mapState } from "vuex";

export default {
    name: "customer-profile-tab",
    props: ["profile", "merchantUuid"],
    components: {
        Datepicker,
        SingleDatepicker
    },
    data() {
        return {
            gender: genders,
            civil_status_options: civil_status_options,
            regchannel: reg_channel,
            countries: countries.getNames(),
            daterangeConfig: {
                altInput: true,
                altFormat: "M j, Y",
                dateFormat: "Y-m-d",
                static: true,
                mode: "range",
                defaultDate: ["today", "today"]
                // onChange: function(selectedDates, dateStr) {
                //     console.log(selectedDates, dateStr);
                // }
            },
            singleDateConfig: {
                altInput: true,
                altFormat: "M j, Y",
                dateFormat: "Y-m-d",
                maxDate: new Date()
            },
            whitelist: null
        };
    },
    created: function() {
        // this.$store.dispatch("customers/getCustomerFields");
        this.getCustomerFields();
        this.getMembership();
        this.getWhitelist();
    },
    computed: {
        ...mapState("customers", [
            "error",
            "errors",
            "notification",
            "form",
            "enable",
            "additional",
            "page",
            "custom_fields"
        ]),
        ...mapState("reportsStores", ["membership_id"]),
        ...mapState("auth", ["enabledTopUps"])
    },
    methods: {
        async getCustomerFields() {
            await this.$store.dispatch("customers/getCustomerFields");
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            try {
                return this.errors['errors'][field] !== undefined ? false : true;
            } catch (error) {}
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            try {
                return this.errors['errors'][field];    
            } catch (error) {}
        },
        isNumber: function(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        updateCustomer: function() {
            let _this = this;

            this.$store.dispatch("customers/updateProfile").then(function() {
                if (_this.error == false) {
                    _this.$store.dispatch("customers/getList", { page: 1 });
                }
            });
        },
        getMembership: async function() {
            await this.$store.dispatch(
                "reportsStores/getCustomerMembershipID",
                {
                    uuid: this.form.uuid,
                    page: this.page
                }
            );
        },
        openCalendar: function(type) {
            // console.log(type);
            let calendar = "datepicker_" + type;
            // console.log(calendar);
            // console.log(this.$refs[calendar].showCalendar());
            this.$refs[calendar].showCalendar();
        },
        getWhitelist: async function() {
            let _this = this;
            await this.$store.dispatch("auth/getTopUps").then(function() {
                _this.whitelist = _this.enabledTopUps.includes("whitelist");
            });
        }
    }
};
</script>
